/**
 * Familiekoden enheten husker (FF-09, #177, epic #167 D4).
 *
 * Settes etter en vellykket innlogging med kode, så neste innlogging på samme
 * enhet bare trenger brukernavn og passord. Bare på denne enheten
 * (localStorage); en privat fane, blokkert lagring eller tømte nettstedsdata
 * gir bare et tomt felt, aldri en feil.
 */
import { normalizeFamilyCode } from '@stell/shared';

const KEY = 'stell.family-code';

export function readRememberedFamilyCode(): string {
  try {
    return window.localStorage.getItem(KEY) ?? '';
  } catch {
    return '';
  }
}

/** Husker koden, eller glemmer den når den er tom (innlogget uten kode). */
export function rememberFamilyCode(raw: string): void {
  const code = normalizeFamilyCode(raw);
  try {
    if (code) window.localStorage.setItem(KEY, code);
    else window.localStorage.removeItem(KEY);
  } catch {
    // Lagring er en bekvemmelighet; innloggingen virket uansett.
  }
}
